<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="">
            <section class="text-gray-600 body-font">

                <div class="bg-gray-100 py-4">
                    <div class="mx-auto max-w-7xl">
                        <div
                            class="mx-auto max-w-7xl pt-4 pb-6 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-6">
                            <div class="flex items-center space-x-5">
                                <div class="flex-shrink-0">
                                    <div class="relative">
                                        <img class="h-16 w-16 rounded-full"
                                             src="https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                                             alt=""/>
                                        <span class="absolute inset-0 rounded-full shadow-inner" aria-hidden="true"/>
                                    </div>
                                </div>
                                <div>
                                    <h1 class="text-2xl font-bold text-gray-900 uppercase">{{
                                            $page.props.user.fullname
                                        }}</h1>
                                    <p class="text-sm font-medium text-gray-500"><a href="#"
                                                                                    class="text-gray-900">{{
                                            $page.props.user.email
                                        }}</a>
                                    </p>
                                </div>
                            </div>
                            <div
                                class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                                <a type="button" :href="route('profile.show')"
                                   class="inline-flex items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
                                    Profile
                                </a>
                            </div>
                        </div>
                        <div v-if="$page.props.user.is_verified != 1">
                            <p>
                                <Message severity="warn" sticky>Pendaftaran DRM periode tanggal 3 – 14 Maret 2025 saat ini sedang dalam proses penilaian oleh Tim Seleksi DRM. </Message>
                                <Message severity="success" sticky>Jika terdapat permasalahan dalam pengisian data perusahaan silahkan hubungi <b>Kantor Pengandan Baranag dan Jasa UNDIP</b> melalui email berikut : <b>kpbj@live.undip.ac.id</b></Message>
                            </p>
                        </div>
                        <div v-if="$page.props.user.is_verified == 2">
                            <p>
                                <Message severity="warn" sticky>Silahkan melanjutkan pendaftaran dengan melengkapi data perusahaan, melalui tombol Lihat pada Data Perusahaan. </Message>
                                <Message severity="success" sticky>Jika terdapat permasalahan dalam pengisian data perusahaan silahkan hubungi <b>Kantor Pengandan Baranag dan Jasa UNDIP</b> melalui email berikut : <b>kpbj@live.undip.ac.id</b></Message>
                            </p>
                        </div>
                        <div class="px-6">
                            <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                                <div v-for="item in stats" :key="item.id"
                                     class="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                                    <dt>
                                        <div class="absolute rounded-md bg-indigo-500 p-3">
                                            <component :is="item.icon" class="h-6 w-6 text-white" aria-hidden="true"/>
                                        </div>
                                        <p class="ml-16 truncate text-sm font-medium text-gray-500">{{ item.name }}</p>
                                    </dt>
                                    <dd class="ml-16 flex items-baseline pb-6 sm:pb-7">
                                        <p>Data Perusahaan</p>
                                        <div class="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                            <div class="text-sm">
                                                <a :href="item.url"
                                                   class="font-medium text-indigo-600 hover:text-indigo-500"
                                                >Lihat</a
                                                >
                                            </div>
                                        </div>
                                    </dd>
                                </div>
                            </dl>
                        </div>
<!--                        <div-->
<!--                            class="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">-->
<!--                            <div class="space-y-6 lg:col-span-2 lg:col-start-1">-->
<!--                                &lt;!&ndash; Description list&ndash;&gt;-->
<!--                                <section aria-labelledby="applicant-information-title">-->
<!--                                    <div class="bg-white shadow sm:rounded-lg">-->
<!--                                        <div class="px-4 py-5 sm:px-6">-->
<!--                                            <h2 id="applicant-information-title"-->
<!--                                                class="text-lg font-medium leading-6 text-gray-900">Pengumuman</h2>-->
<!--                                            <p class="mt-1 max-w-2xl text-sm text-gray-500">Pengumuman dari KPBJ Undip</p>-->
<!--                                        </div>-->
<!--                                        <div class="border-t border-gray-200 px-4 py-5 sm:px-6">-->
<!--                                            <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">-->
<!--                                                <div class="sm:col-span-1">-->
<!--                                                    <dt class="text-sm font-medium text-gray-500">Application for</dt>-->
<!--                                                    <dd class="mt-1 text-sm text-gray-900">Backend Developer</dd>-->
<!--                                                </div>-->
<!--                                                <div class="sm:col-span-1">-->
<!--                                                    <dt class="text-sm font-medium text-gray-500">Email address</dt>-->
<!--                                                    <dd class="mt-1 text-sm text-gray-900">ricardocooper@example.com-->
<!--                                                    </dd>-->
<!--                                                </div>-->
<!--                                                <div class="sm:col-span-1">-->
<!--                                                    <dt class="text-sm font-medium text-gray-500">Salary expectation-->
<!--                                                    </dt>-->
<!--                                                    <dd class="mt-1 text-sm text-gray-900">$120,000</dd>-->
<!--                                                </div>-->
<!--                                                <div class="sm:col-span-1">-->
<!--                                                    <dt class="text-sm font-medium text-gray-500">Phone</dt>-->
<!--                                                    <dd class="mt-1 text-sm text-gray-900">+1 555-555-5555</dd>-->
<!--                                                </div>-->
<!--                                                <div class="sm:col-span-2">-->
<!--                                                    <dt class="text-sm font-medium text-gray-500">About</dt>-->
<!--                                                    <dd class="mt-1 text-sm text-gray-900">Fugiat ipsum ipsum deserunt-->
<!--                                                        culpa aute sint do nostrud anim incididunt cillum culpa-->
<!--                                                        consequat. Excepteur qui ipsum aliquip consequat sint. Sit id-->
<!--                                                        mollit nulla mollit nostrud in ea officia proident. Irure-->
<!--                                                        nostrud pariatur mollit ad adipisicing reprehenderit deserunt-->
<!--                                                        qui eu.-->
<!--                                                    </dd>-->
<!--                                                </div>-->
<!--                                                <div class="sm:col-span-2">-->
<!--                                                    <dt class="text-sm font-medium text-gray-500">Attachments</dt>-->
<!--                                                    <dd class="mt-1 text-sm text-gray-900">-->
<!--                                                        <ul role="list"-->
<!--                                                            class="divide-y divide-gray-200 rounded-md border border-gray-200">-->
<!--                                                            <li v-for="attachment in attachments" :key="attachment.name"-->
<!--                                                                class="flex items-center justify-between py-3 pl-3 pr-4 text-sm">-->
<!--                                                                <div class="flex w-0 flex-1 items-center">-->
<!--                                                                    <PaperClipIcon-->
<!--                                                                        class="h-5 w-5 flex-shrink-0 text-gray-400"-->
<!--                                                                        aria-hidden="true"/>-->
<!--                                                                    <span class="ml-2 w-0 flex-1 truncate">{{-->
<!--                                                                            attachment.name-->
<!--                                                                        }}</span>-->
<!--                                                                </div>-->
<!--                                                                <div class="ml-4 flex-shrink-0">-->
<!--                                                                    <a :href="attachment.href"-->
<!--                                                                       class="font-medium text-blue-600 hover:text-blue-500">Download</a>-->
<!--                                                                </div>-->
<!--                                                            </li>-->
<!--                                                        </ul>-->
<!--                                                    </dd>-->
<!--                                                </div>-->
<!--                                            </dl>-->
<!--                                        </div>-->
<!--                                        <div>-->
<!--                                            <a href="#"-->
<!--                                               class="block bg-gray-50 px-4 py-4 text-center text-sm font-medium text-gray-500 hover:text-gray-700 sm:rounded-b-lg">Read-->
<!--                                                full application</a>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </section>-->

<!--                                &lt;!&ndash; Comments&ndash;&gt;-->
<!--                            </div>-->

<!--                            <section aria-labelledby="timeline-title" class="lg:col-span-1 lg:col-start-3">-->
<!--                                <div class="bg-white px-4 py-5 shadow sm:rounded-lg sm:px-6">-->
<!--                                    <h2 id="timeline-title" class="text-lg font-medium text-gray-900">Daftar-->
<!--                                        Pengadaan</h2>-->

<!--                                    &lt;!&ndash; Activity Feed &ndash;&gt;-->
<!--                                    <div class="mt-6 flow-root">-->
<!--                                        <ul role="list" class="-mb-8">-->
<!--                                            <li v-for="(item, itemIdx) in timeline" :key="item.id">-->
<!--                                                <div class="relative pb-8">-->
<!--                                                <span v-if="itemIdx !== timeline.length - 1"-->
<!--                                                      class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"-->
<!--                                                      aria-hidden="true"/>-->
<!--                                                                                                    <div class="relative flex space-x-3">-->
<!--                                                                                                        <div>-->
<!--                                                <span-->
<!--                                                    :class="[item.type.bgColorClass, 'flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white']">-->
<!--                                                <component :is="item.type.icon" class="h-5 w-5 text-white" aria-hidden="true"/>-->
<!--                                                </span>-->
<!--                                                        </div>-->
<!--                                                        <div-->
<!--                                                            class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">-->
<!--                                                            <div>-->
<!--                                                                <p class="text-sm text-gray-500">-->
<!--                                                                    {{ item.content }} <a href="#"-->
<!--                                                                                          class="font-medium text-gray-900">{{-->
<!--                                                                        item.target-->
<!--                                                                    }}</a>-->
<!--                                                                </p>-->
<!--                                                            </div>-->
<!--                                                            <div-->
<!--                                                                class="whitespace-nowrap text-right text-sm text-gray-500">-->
<!--                                                                <time :datetime="item.datetime">{{ item.date }}</time>-->
<!--                                                            </div>-->
<!--                                                        </div>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </li>-->
<!--                                        </ul>-->
<!--                                    </div>-->
<!--                                    <div class="mt-6 flex flex-col justify-stretch">-->
<!--                                        <button type="button"-->
<!--                                                class="inline-flex items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">-->
<!--                                            Tampilkan Lebih Banyak-->
<!--                                        </button>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </section>-->
<!--                        </div>-->
                    </div>
                </div>
            </section>
        </div>
    </app-layout>
</template>

<script >
import {defineComponent} from "vue";
import AppLayout from "@/Layouts/AppLayout";
import IconPenyedia from "@/Icons/Penyedia";
import IconUser from "@/Icons/User";
import Badge from "primevue/badge";
import Message from "primevue/message";

import IconAdd from "@/Icons/Add";
import {Link} from "@inertiajs/inertia-vue3";
import {
    ArrowLongLeftIcon,
    CheckIcon,
    HandThumbUpIcon,
    HomeIcon,
    MagnifyingGlassIcon,
    PaperClipIcon,
    QuestionMarkCircleIcon,
    UserIcon,
} from '@heroicons/vue/20/solid';
import {ArrowDownIcon, ArrowUpIcon} from '@heroicons/vue/20/solid'
import {CursorArrowRaysIcon, EnvelopeOpenIcon, UsersIcon} from '@heroicons/vue/24/outline'


export default defineComponent({
    components: {
        AppLayout,
        IconPenyedia,
        IconUser,
        Badge,
        IconAdd,
        Link,
    },
    data() {
        return {
            stats: [
                {
                    id: 'penyedia',
                    name: 'Data Perusahaan',
                    icon: UsersIcon,
                    url: route('penyedia.infocompletion'),
                },
            ],
            eventTypes: [
                {
                    id: 1,
                    name: 'applied',
                    bgColorClass: 'bg-blue-500',
                    icon: UserIcon,
                },
                {
                    id: 2,
                    name: 'advanced',
                    bgColorClass: 'bg-indigo-500',
                    icon: QuestionMarkCircleIcon,
                },
                {
                    id: 3,
                    name: 'completed',
                    bgColorClass: 'bg-green-500',
                    icon: CheckIcon,
                },
            ],
            timeline: [
                {
                    id: 1,
                    type: {
                        id: 1,
                        name: 'applied',
                        bgColorClass: 'bg-blue-500',
                        icon: UserIcon,
                    },
                    content: 'Applied to',
                    target: 'Front End Developer',
                    date: 'Sep 20',
                    datetime: '2020-09-20',
                },
                {
                    id: 2,
                    type: {
                        id: 2,
                        name: 'advanced',
                        bgColorClass: 'bg-indigo-500',
                        icon: QuestionMarkCircleIcon,
                    },
                    content: 'Advanced to phone screening by',
                    target: 'Bethany Blake',
                    date: 'Sep 22',
                    datetime: '2020-09-22',
                },
                {
                    id: 3,
                    type: {
                        id: 2,
                        name: 'advanced',
                        bgColorClass: 'bg-indigo-500',
                        icon: QuestionMarkCircleIcon,
                    },
                    content: 'Completed phone screening with',
                    target: 'Martha Gardner',
                    date: 'Sep 28',
                    datetime: '2020-09-28',
                },
                {
                    id: 4,
                    type: {
                        id: 2,
                        name: 'advanced',
                        bgColorClass: 'bg-indigo-500',
                        icon: QuestionMarkCircleIcon,
                    },
                    content: 'Advanced to interview by',
                    target: 'Bethany Blake',
                    date: 'Sep 30',
                    datetime: '2020-09-30',
                },
                {
                    id: 5,
                    type: {
                        id: 2,
                        name: 'advanced',
                        bgColorClass: 'bg-indigo-500',
                        icon: QuestionMarkCircleIcon,
                    },
                    content: 'Completed interview with',
                    target: 'Katherine Snyder',
                    date: 'Oct 4',
                    datetime: '2020-10-04',
                },
            ]
        };
    },
    methods: {
    },
    mounted() {
    },

});

</script>
